import store from '@/store';

export default class BroadcastWhatsAppListScheduleUpdateEvent {
  constructor(body) {
    const agentId = store.state.attendance.Attendance.agentId;
    const broadcastWhatsAppId = body.whatsappBroadcastListId;
    const schedule = { status: body.status, scheduleId: body.id };
    if (
      body.event == 'BroadcastWhatsAppListScheduleUpdateEvent' &&
      agentId == body.agentId
    ) {
      const broadcastInformation = {
        broadcastWhatsAppId,
        schedule,
        type: 'update-schedule',
      };
      store.dispatch(
        'broadcast/updateBroadcastWhatsAppStatus',
        broadcastInformation,
      );
      console.log(
        '[AGENT/BROADCAST] - Broadcast ' + broadcastWhatsAppId + ' enviado.',
      );
    }
  }
}
